import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { AnrokRegisterFormSchema, type AnrokRegisterFormValues } from './AnrokRegisterFormSchema';
import { AnrokRegistration } from './components/AnrokRegistration';
import { AnrokRegistrationFooter } from './components/AnrokRegistrationFooter';

export const RegisterToAnrokComponents: FormDrawerProps<ZodSchema<AnrokRegisterFormValues>> = {
  zodSchema: AnrokRegisterFormSchema,
  ContentComponent: AnrokRegistration,
  Footer: AnrokRegistrationFooter,
};
